import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_406: DocMigration = {
  maxSchemaVersion: "0.0.406",
  description: "Add flag to preserve legacy sweep bounds calculation behavior",
  apply(json: any) {
    if (!json.facadeSweepStrata) {
      return json;
    }

    for (const sweepId in json.facadeSweepStrata) {
      json.facadeSweepStrata[sweepId].sweep.useLegacyWallGapBounds = true;
    }

    return json;
  },
};

export default migration_0_0_406;
